// hero
document.addEventListener('DOMContentLoaded', () => {
	if (document.querySelectorAll('.hero-image').length > 0) {
		function adjustBackgroundPosition() {
			const heroImages = document.querySelectorAll('.hero-image');
			const isDesktop = window.innerWidth >= 768;

			heroImages.forEach(image => {
				let offsetX = image.getAttribute('data-offset-x');
				let offsetY = image.getAttribute('data-offset-y');
				const imgChild = image.querySelector('img');
				if (isDesktop) {
					if (offsetX !== '-9999' || offsetY !== '-9999') {
						const existingBackgroundImage = image.style.backgroundImage || '';
						offsetX = offsetX === '-9999' ? 'center' : offsetX + 'px';
						offsetY = offsetY === '-9999'? 'center' : offsetY + 'px';
						image.style.backgroundPosition = `${offsetX} ${offsetY}`;
						imgChild.style.objectPosition = `${offsetX} ${offsetY}`;
					} else {
						// Remove background-position if data attributes are empty
						image.style.backgroundPosition = '';
					}
				} else {
					// Remove background-position on mobile
					image.style.backgroundPosition = '';
				}
			});
		}

		// Adjust background position on initial load
		adjustBackgroundPosition();

		// Adjust background position on window resize
		window.addEventListener('resize', adjustBackgroundPosition);
		
		// let previousWidth = window.innerWidth;

		const adjustFontSize = (element) => {
			const container = element.parentElement.closest('.hero-content') ? element.parentElement.closest('.hero-content') : element.parentElement;
			const focalContentContainer = element.closest('.hero-focal-content');
			const isFocalContent = !!focalContentContainer;
			let fontSize = parseInt(window.getComputedStyle(element).fontSize);
			const maxFontSize = parseInt(window.getComputedStyle(element).maxFontSize) > 72 ? 72 : parseInt(window.getComputedStyle(element).maxFontSize) || 72; // Default to 72px max if not set
			const minFontSize = 40; // Set a minimum font size

			const paddingTop = parseInt(window.getComputedStyle(container).paddingTop);
			const paddingBottom = parseInt(window.getComputedStyle(container).paddingBottom);
			const availableHeight = container.clientHeight - paddingTop - paddingBottom;

			if (window.innerWidth > 768) {
				while (true) {
					element.style.fontSize = `${fontSize}px`;

					const elementScrollWidth = isFocalContent ? focalContentContainer.scrollWidth : element.scrollWidth;
					const elementScrollHeight = isFocalContent ? focalContentContainer.scrollHeight : element.scrollHeight;

					if ((elementScrollWidth > container.clientWidth || elementScrollHeight > availableHeight) && fontSize > minFontSize) {
						fontSize -= 1;
					} else {
						break;
					}
				}

				while (true) {
					element.style.fontSize = `${fontSize}px`;

					const elementScrollWidth = isFocalContent ? focalContentContainer.scrollWidth : element.scrollWidth;
					const elementScrollHeight = isFocalContent ? focalContentContainer.scrollHeight : element.scrollHeight;

					if ((elementScrollWidth <= container.clientWidth && elementScrollHeight <= availableHeight) && fontSize < maxFontSize) {
						fontSize += 1;
					} else {
						if (fontSize > minFontSize) {
							fontSize -= 1;
							if (fontSize > 72) {
								fontSize = 72;
							}
							element.style.fontSize = `${fontSize}px`;
						}
						break;
					}
				}
			} else {
				document.querySelectorAll('.hero-title').forEach(element => element.removeAttribute('style'));
			}
		};
		
		document.querySelectorAll('.hero-carousel .hero-title').forEach(adjustFontSize);

		window.addEventListener('resize', () => {
			document.querySelectorAll('.hero-carousel .hero-title').forEach(adjustFontSize);
		});
	}
});